import { StatusClassParams } from '@app/shared/enum/StatusClassParams';

export class StudentClassesCourseConfirmedParams {
    studentClassesCourseId: number;
    statusClassParams: StatusClassParams;
    confirmedAddInfo: string;
    episode: number;
}
